/**
 * Padrão de texto do Kanban (5663): inicial maiúscula em cada palavra, conectivos em minúsculas
 * ("Feira de Santana") e UF com duas letras. Reaproveitado nas listas e no modal de veículos.
 */
const CONNECTORS = new Set(['de', 'da', 'das', 'do', 'dos', 'e']);

const STATES = {
  acre: 'AC',
  alagoas: 'AL',
  amapa: 'AP',
  amazonas: 'AM',
  bahia: 'BA',
  ceara: 'CE',
  'distrito federal': 'DF',
  'espirito santo': 'ES',
  goias: 'GO',
  maranhao: 'MA',
  'mato grosso': 'MT',
  'mato grosso do sul': 'MS',
  'minas gerais': 'MG',
  para: 'PA',
  paraiba: 'PB',
  parana: 'PR',
  pernambuco: 'PE',
  piaui: 'PI',
  'rio de janeiro': 'RJ',
  'rio grande do norte': 'RN',
  'rio grande do sul': 'RS',
  rondonia: 'RO',
  roraima: 'RR',
  'santa catarina': 'SC',
  'sao paulo': 'SP',
  sergipe: 'SE',
  tocantins: 'TO',
};

const plain = (text) =>
  text
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLocaleLowerCase('pt-BR')
    .trim()
    .replace(/\s+/g, ' ');

export function titleCase(value) {
  if (typeof value !== 'string') return value;
  return value
    .trim()
    .toLocaleLowerCase('pt-BR')
    .split(/(\s+)/)
    .map((word, index) =>
      index > 0 && CONNECTORS.has(word)
        ? word
        : word.replace(
            // "d'" segue minúsculo, como em "Mirassol d'Oeste"; a letra seguinte sobe.
            /(^d'|^|[^\p{L}\p{N}'])(\p{L})/gu,
            (_, before, letter) => before + letter.toLocaleUpperCase('pt-BR'),
          ),
    )
    .join('')
    .replace(/^\p{Ll}/u, (letter) => letter.toLocaleUpperCase('pt-BR'));
}

/** Razão social e placas ficam em maiúsculas. */
export const upperCase = (value) =>
  typeof value === 'string' ? value.trim().toLocaleUpperCase('pt-BR') : value;

/** Sigla da UF (duas letras) pelo nome ou pela própria sigla; desconhecido devolve null. */
export function ufCode(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  const key = plain(value);
  if (/^[a-z]{2}$/.test(key)) return key.toUpperCase();
  return STATES[key] || null;
}

/** UF brasileira em duas letras; província de outro país segue com inicial maiúscula. */
export function stateCode(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  return ufCode(value) || titleCase(value);
}

/** "Caucaia - CE": cidade com inicial maiúscula e UF com duas letras. */
export const placeLabel = (point) =>
  [titleCase(point?.city), stateCode(point?.province)].filter(Boolean).join(' - ');
